module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colla', {
    staticClass: "collapp-comment-box",
    attrs: {
      "id": "collapp-comment"
    }
  }, [_c('colla', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "collapp-loader"
  }, [_c('colla', {
    staticClass: "collapp-spinner"
  })], 1), _vm._v(" "), _c('form', {
    attrs: {
      "action": "",
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.message),
      expression: "data.message"
    }],
    staticClass: "collapp-input-message",
    attrs: {
      "name": "message",
      "id": "collapp-message",
      "rows": "3",
      "placeholder": "Your comment...",
      "required": ""
    },
    domProps: {
      "value": (_vm.data.message)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "message", $event.target.value)
      }, _vm.showFullForm]
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.name),
      expression: "data.name"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.fullForm),
      expression: "fullForm"
    }],
    staticClass: "collapp-input-name",
    attrs: {
      "type": "text",
      "name": "name",
      "placeholder": "Your Name",
      "required": ""
    },
    domProps: {
      "value": (_vm.data.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.thread),
      expression: "data.thread"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.fullForm),
      expression: "fullForm"
    }],
    staticClass: "collapp-input-name",
    attrs: {
      "type": "hidden",
      "name": "thread"
    },
    domProps: {
      "value": (_vm.data.thread)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "thread", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fullForm),
      expression: "fullForm"
    }],
    staticClass: "collapp-input-submit",
    attrs: {
      "disabled": _vm.loading,
      "type": "submit",
      "value": "Comment"
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-27e0ea7c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/CommentForm.vue
// module id = 24
// module chunks = 0